import React from 'react';
import { withTranslation } from 'react-i18next';
import {
  CustomInput,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
} from 'reactstrap';
import { Dropdown, Input } from '../Common';
import { DropdownButton } from '../DropdownBtn';
import { debounce } from 'lodash';

export const sizePerPageRenderer = (
  { options, currSizePerPage, onSizePerPageChange },
  updateSizePerPage,
) => {
  return (
    <Dropdown
      noLabel
      data={options}
      value={currSizePerPage}
      onChange={({ value }) => {
        onSizePerPageChange(value);
        updateSizePerPage(value);
      }}
      valueKey="page"
      nameKey="text"
      containerClasses="mb-0"
      dropdownToggleStyle={{ minWidth: 'unset' }}
    />
  );
};

export const paginationTotalRenderer = (from, to, size, t) => {
  return (
    <span className="react-bootstrap-table-pagination-total">
      {t('Showing')} {from} {t('to')} {to} {t('of')} {size} {t('Results')}
    </span>
  );
};

export const ExportDropdown = withTranslation('app')(
  ({ onExport, t, customExportProps, ...props }) => {
    function renderCustom() {
      return customExportProps.map((opt, index) => (
        <React.Fragment key={index}>
          <DropdownItem
            style={{ boxSizing: 'border-box' }}
            onClick={opt.action}
            key={index}
          >
            {t(opt.name)}
          </DropdownItem>
          {index + 1 !== customExportProps.length ? (
            <DropdownItem divider />
          ) : null}
        </React.Fragment>
      ));
    }
    return (
      <FormGroup className="ml-10">
        <DropdownButton id="exportDropdown">
          <DropdownToggle
            caret
            id="export"
            color="secondary"
            style={{ minWidth: 50 }}
          >
            <i className="md-icon">cloud_download</i>
          </DropdownToggle>
          <DropdownMenu right>
            {customExportProps ? (
              renderCustom()
            ) : (
              <DropdownItem
                style={{ boxSizing: 'border-box' }}
                onClick={() => onExport()}
              >
                {t('Export to CSV')}
              </DropdownItem>
            )}
          </DropdownMenu>
        </DropdownButton>
      </FormGroup>
    );
  },
);

export const RemoteSearchBar = ({ searchText, onSearch, ...props }) => {
  function handleChange(e) {
    onSearch(e.target.value);
    props.onPageChange(1);
  }
  return (
    <Input
      labelHidden
      id={props.id}
      containerClass="mb-0"
      placeholder={props.placeholder}
      value={searchText}
      onChange={handleChange}
    />
  );
};

export const SearchBar = (props) => {
  const [text, setText] = React.useState('');
  function handleChange(e) {
    setText(e.target.value);
    props.onPageChange(1);
  }
  React.useEffect(() => {
    props.onSearch(text);
  }, [text]);
  return (
    <Input
      labelHidden
      id={props.id}
      containerClass="mb-0"
      placeholder={props.placeholder}
      value={text}
      onChange={handleChange}
    />
  );
};

export const selectionHeaderRenderer = ({ indeterminate, ...rest }) => {
  return (
    <CustomInput
      type="checkbox"
      ref={(input) => {
        if (input) input.indeterminate = indeterminate;
      }}
      {...rest}
    />
  );
};
